{
  "title": "Ajouter l'entité liée",
  "relationship": "Relation",
  "relationshipTo": "Relation avec {{whom}}",
  "alreadyRelatedTo": "L'entité est déjà liée à",
  "thisClient": "ce client",
  "pleaseReview": "Veuillez passer en revue vos renseignements afin de vérifier leur exactitude.",
  "name": "Nom",
  "continue": "Continuer",
  "added": "{{entityName}} a été ajoutée comme entité liée",
  "failed": "Échec d'une nouvelle entité liée.",
  "done": "Terminé"
}
